import { TenantUpdate } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateTenantQueries } from "@/queries/query-tenant";

export const useEditTenant = () => {
  const updateTenantQueries = useUpdateTenantQueries();
  return useMutationWithErrorHandler(async (tenantUpdate: TenantUpdate) => {
    const result = await getRanaApiV1().TenantsApi.tenantUpdate({ tenantUpdate });
    updateTenantQueries(result.id, result);
  });
};
